/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * a Template field
 * @export
 * @interface BridgeApiTemplateField
 */
export interface BridgeApiTemplateField {
    /**
     * 
     * @type {string}
     * @memberof BridgeApiTemplateField
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiTemplateField
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiTemplateField
     */
    displayName: string;
    /**
     * 
     * @type {BridgeApiTemplateFieldTypeEnum}
     * @memberof BridgeApiTemplateField
     */
    type: BridgeApiTemplateFieldTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof BridgeApiTemplateField
     */
    required: boolean;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiTemplateField
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof BridgeApiTemplateField
     */
    sortOrder: number;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiTemplateField
     */
    placeholder?: string;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiTemplateField
     */
    _configuration?: string;
}

/**
* @export
* @enum {string}
*/
export enum BridgeApiTemplateFieldTypeEnum {
    TEXT = 'TEXT',
    TEXTAREA = 'TEXTAREA',
    NUMBER = 'NUMBER',
    DATE = 'DATE',
    BOOLEAN = 'BOOLEAN',
    FILE = 'FILE',
    SELECT = 'SELECT'
}


/**
 * Check if a given object implements the BridgeApiTemplateField interface.
 */
export function instanceOfBridgeApiTemplateField(value: object): value is BridgeApiTemplateField {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('required' in value) || value['required'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    return true;
}

export function BridgeApiTemplateFieldFromJSON(json: any): BridgeApiTemplateField {
    return BridgeApiTemplateFieldFromJSONTyped(json, false);
}

export function BridgeApiTemplateFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): BridgeApiTemplateField {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'displayName': json['displayName'],
        'type': json['type'],
        'required': json['required'],
        'description': json['description'] == null ? undefined : json['description'],
        'sortOrder': json['sortOrder'],
        'placeholder': json['placeholder'] == null ? undefined : json['placeholder'],
        '_configuration': json['configuration'] == null ? undefined : json['configuration'],
    };
}

export function BridgeApiTemplateFieldToJSON(json: any): BridgeApiTemplateField {
    return BridgeApiTemplateFieldToJSONTyped(json, false);
}

export function BridgeApiTemplateFieldToJSONTyped(value?: BridgeApiTemplateField | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'displayName': value['displayName'],
        'type': value['type'],
        'required': value['required'],
        'description': value['description'],
        'sortOrder': value['sortOrder'],
        'placeholder': value['placeholder'],
        'configuration': value['_configuration'],
    };
}

